module.exports = __webpack_public_path__ + "img/products_big_can_bananas.f4e5d569.png";